// (function () {
//   if (window.customElements && !customElements.get('collection-facets-root')) {
//     var MOBILE_MAX_WIDTH = 991;

//     function isMobile() {
//       return window.innerWidth <= MOBILE_MAX_WIDTH;
//     }

//     function createSearchParamsFromUrl(url) {
//       try {
//         var u = new URL(url, window.location.origin);
//         return new URLSearchParams(u.search);
//       } catch (e) {
//         return new URLSearchParams();
//       }
//     }

//     var CollectionFacetsRoot = (function () {
//       function CollectionFacetsRoot() {
//         var self = Reflect.construct(HTMLElement, [], CollectionFacetsRoot);
//         self._initialized = false;
//         self.sectionId = '';
//         self.abortController = null;

//         self.onFacetChangeHandler = function (event) {
//           self.onFacetChange(event);
//         };
//         self.onFacetFormSubmitHandler = function (event) {
//           self.onFacetFormSubmit(event);
//         };
//         self.onPaginationClickHandler = function (event) {
//           self.onPaginationClick(event);
//         };
//         self.onFilterLinkClickHandler = function (event) {
//           self.onFilterLinkClick(event);
//         };
//         self.onSortChangeHandler = function (event) {
//           self.onSortChange(event);
//         };
//         self.onDialogTabClickHandler = function (event) {
//           self.onDialogTabClick(event);
//         };
//         self.onHorizontalTriggerClickHandler = function (event) {
//           self.onHorizontalTriggerClick(event);
//         };
//         self.onSortDialogTriggerClickHandler = function (event) {
//           self.onSortDialogTriggerClick(event);
//         };
//         return self;
//       }

//       CollectionFacetsRoot.prototype = Object.create(HTMLElement.prototype);
//       CollectionFacetsRoot.prototype.constructor = CollectionFacetsRoot;

//       CollectionFacetsRoot.prototype.connectedCallback = function () {
//         if (this._initialized) return;
//         this._initialized = true;

//         this.sectionId = this.getAttribute('data-section-id') || '';
//         this.bindAll();
//         this.bindResizeWatcher();
//       };

//       // ---------- Helpers ----------

//       CollectionFacetsRoot.prototype.getContainer = function () {
//         return this.querySelector('.main-collection-contain');
//       };

//       CollectionFacetsRoot.prototype.getDialog = function () {
//         if (!this.sectionId) return null;
//         return document.getElementById('filterTabDrawer-' + this.sectionId);
//       };

//       // Returns BOTH desktop & dialog forms
//       CollectionFacetsRoot.prototype.getFilterForms = function () {
//         var list = [];

//         // forms inside this section root
//         var inside = this.querySelectorAll('form.facets-filter-form[data-facets-form]');
//         for (var i = 0; i < inside.length; i++) {
//           list.push(inside[i]);
//         }

//         // forms inside the dialog
//         var dialog = this.getDialog();
//         if (dialog) {
//           var dlgForms = dialog.querySelectorAll('form.facets-filter-form[data-facets-form]');
//           for (var j = 0; j < dlgForms.length; j++) {
//             list.push(dlgForms[j]);
//           }
//         }

//         return list;
//       };

//       // horizontal layout = container has an element with .horizontal-filters
//       CollectionFacetsRoot.prototype.isHorizontalFiltersActive = function () {
//         var container = this.getContainer();
//         if (!container) return false;
//         return !!container.querySelector('.horizontal-filters');
//       };

//       CollectionFacetsRoot.prototype.bindAll = function () {
//         this.bindFacetEvents();
//         this.bindPaginationLinks();
//         this.bindFilterChips();
//         this.bindSortControls();
//         this.initPriceRanges();
//         this.bindHorizontalFilterTriggers();
//         this.bindDialogTabs();
//         this.bindDialogClose();
//         this.bindMobileClearFilters();
//         this.bindMobileDragToClose();
//         this.bindSortDialogTriggers();
//         this.bindMobilePanelClose();
//       };

//       // ---------- Facet inputs (checkboxes, selects) ----------

//       CollectionFacetsRoot.prototype.bindFacetEvents = function () {
//         var forms = this.getFilterForms();
//         for (var i = 0; i < forms.length; i++) {
//           var form = forms[i];

//           if (form.getAttribute('data-facets-events-bound') === 'true') {
//             continue;
//           }
//           form.setAttribute('data-facets-events-bound', 'true');

//           form.addEventListener('submit', this.onFacetFormSubmitHandler);

//           var inputs = form.querySelectorAll('input[name^="filter."], select[name^="filter."]');
//           for (var j = 0; j < inputs.length; j++) {
//             inputs[j].addEventListener('change', this.onFacetChangeHandler);
//           }
//         }
//       };

//       CollectionFacetsRoot.prototype.onFacetChange = function (event) {
//         var target = event.target || event.srcElement;
//         if (!target) return;

//         var form = target.form;
//         if (!form) return;

//         this.syncFacetControlState(target);
//         this.syncActiveFilterCounts(target.name);
        
//         // ignore price numeric inputs here (handled via price logic)
//         if (
//           target.classList &&
//           (target.classList.contains('input-price-min') ||
//             target.classList.contains('input-price-max'))
//         ) {
//           return;
//         }

//         var horizontal = this.isHorizontalFiltersActive();

//         // Horizontal layout: always apply on Apply button (desktop + mobile)
//         if (horizontal) {
//           var submitBtn = form.querySelector('button[type="submit"]');
//           if (submitBtn) {
//             submitBtn.disabled = false;
//             submitBtn.classList.add('facets-submit-active');
//           }
//           return;
//         }

//         // Non-horizontal layout:
//         // mobile => enable submit
//         if (isMobile()) {
//           var mobileBtn = form.querySelector('button[type="submit"]');
//           if (mobileBtn) {
//             mobileBtn.disabled = false;
//             mobileBtn.classList.add('facets-submit-active');
//           }
//           return;
//         }

//         // desktop => auto-apply
//         this.preventEvent(event);
//         this.updateCollectionFromState();
//       };

//       CollectionFacetsRoot.prototype.onFacetFormSubmit = function (event) {
//         this.preventEvent(event);

//         var form = event.target || event.srcElement;
//         if (form && form.closest) {
//           var dlg = form.closest('dialog');
//           if (dlg) {
//             // On apply, close instantly (no slide) for faster feedback
//             this.closeDialog(dlg);
//           }
//         }

//         this.updateCollectionFromState();
//       };

//       // ---------- Sort controls ----------

//       CollectionFacetsRoot.prototype.bindSortControls = function () {
//         var container = this.getContainer();
//         if (!container) return;

//         var sortInputs = container.querySelectorAll('.utility-select-option input[name="sort_by"]');
//         for (var i = 0; i < sortInputs.length; i++) {
//           sortInputs[i].addEventListener('change', this.onSortChangeHandler);
//         }
//       };

//       CollectionFacetsRoot.prototype.onSortChange = function (event) {
//         // always apply sort immediately (desktop + mobile)
//         this.preventEvent(event);
//         this.updateCollectionFromState();
//       };

//       // ---------- Pagination ----------

//       CollectionFacetsRoot.prototype.bindPaginationLinks = function () {
//         var container = this.getContainer();
//         if (!container) return;

//         var paginationRoot = container.querySelector('[data-collection-pagination]');
//         if (!paginationRoot) return;

//         var links = paginationRoot.querySelectorAll('a[href]');
//         for (var i = 0; i < links.length; i++) {
//           if (links[i].getAttribute('aria-disabled') === 'true') continue;
//           links[i].addEventListener('click', this.onPaginationClickHandler);
//         }
//       };

//       CollectionFacetsRoot.prototype.onPaginationClick = function (event) {
//         this.preventEvent(event);

//         var href = event.currentTarget.getAttribute('href');
//         if (!href) return;

//         var params = createSearchParamsFromUrl(href);
//         this.fetchSection(params);
//       };

//       // ---------- Filter chips (applied filters) ----------

//       CollectionFacetsRoot.prototype.bindFilterChips = function () {
//         var container = this.getContainer();
//         if (!container) return;

//         var links = container.querySelectorAll(
//           '.utility-apply-facet a[href], .utility-apply-clear a[href]'
//         );

//         for (var i = 0; i < links.length; i++) {
//           links[i].addEventListener('click', this.onFilterLinkClickHandler);
//         }
//       };

//       CollectionFacetsRoot.prototype.onFilterLinkClick = function (event) {
//         this.preventEvent(event);

//         var href = event.currentTarget.getAttribute('href');
//         if (!href || href === '#') {
//           href = window.location.pathname;
//         }

//         var params = createSearchParamsFromUrl(href);
//         this.fetchSection(params);
//       };

//       // ---------- Build params + AJAX fetch ----------

//       CollectionFacetsRoot.prototype.updateCollectionFromState = function () {
//         var currentParams = new URLSearchParams(window.location.search);
//         var newParams = new URLSearchParams();
//         var seenFilterValues = Object.create(null);

//         // Preserve non-filter params ONCE
//         currentParams.forEach(function (value, key) {
//           if (key.indexOf('filter.') === 0) return;
//           if (key === 'page') return;
//           if (key === 'sort_by') return;

//           if (!newParams.has(key)) {
//             newParams.set(key, value);
//           }
//         });

//         var priceTouched = false;

//         var forms = this.getFilterForms();
//         for (var i = 0; i < forms.length; i++) {
//           var form = forms[i];
//           var fd = new FormData(form);

//           // detect price intent from DOM flag
//           var priceContainer = form.querySelector('[data-price-range]');
//           if (priceContainer && priceContainer._priceTouched === true) {
//             priceTouched = true;
//           }

//           fd.forEach(function (value, key) {
//             if (value === '') return;

//             // Skip price if not touched
//             if (
//               (key.indexOf('filter.v.price.gte') === 0 ||
//                 key.indexOf('filter.v.price.lte') === 0) &&
//               !priceTouched
//             ) {
//               return;
//             }

//             // Allow multiple filter values
//             if (key.indexOf('filter.') === 0) {
//               var dedupeKey = key + '\u0000' + value;
//               if (seenFilterValues[dedupeKey]) {
//                 return;
//               }
//               seenFilterValues[dedupeKey] = true;
//               newParams.append(key, value);
//               return;
//             }

//             // Single value params
//             if (!newParams.has(key)) {
//               newParams.set(key, value);
//             }
//           });
//         }

//         // Apply sort_by (always explicit)
//         var container = this.getContainer();
//         if (container) {
//           // var checkedSort = container.querySelector(
//           //   '.utility-select-option input[name="sort_by"]:checked'
//           // );
//           // if (checkedSort && checkedSort.value) {
//           //   newParams.set('sort_by', checkedSort.value);
//           // }
//           var sortValue = this.getActiveSortValue();
//           if (sortValue) {
//             newParams.set('sort_by', sortValue);
//           }
//         }

//         this.fetchSection(newParams);
//       };

//       CollectionFacetsRoot.prototype.fetchSection = function (searchParams) {
//         var container = this.getContainer();
//         if (!container) return;

//         if (this.abortController && typeof this.abortController.abort === 'function') {
//           this.abortController.abort();
//         }

//         var signal = null;
//         if (window.AbortController) {
//           this.abortController = new AbortController();
//           signal = this.abortController.signal;
//         } else {
//           this.abortController = null;
//         }

//         if (this.sectionId) {
//           searchParams.set('section_id', this.sectionId);
//         }

//         var url = window.location.pathname + '?' + searchParams.toString();

//         container.classList.add('is-loading');

//         var fetchOptions = {
//           headers: { 'X-Requested-With': 'XMLHttpRequest' }
//         };
//         if (signal) {
//           fetchOptions.signal = signal;
//         }

//         fetch(url, fetchOptions)
//           .then(function (response) {
//             return response.text();
//           })
//           .then(
//             function (html) {
//               if (signal && signal.aborted) return;

//               var temp = document.createElement('div');
//               temp.innerHTML = html;

//               // New main container inside section HTML
//               var newContainer;
//               if (this.sectionId) {
//                 newContainer = temp.querySelector(
//                   '.main-collection-contain[data-section-id="' + this.sectionId + '"]'
//                 );
//               }
//               if (!newContainer) {
//                 newContainer = temp.querySelector('.main-collection-contain');
//               }

//               // 🔥 NEW: also grab new dialog HTML from section
//               var newDialog = null;
//               if (this.sectionId) {
//                 newDialog = temp.querySelector('#filterTabDrawer-' + this.sectionId);
//               }

//               if (!newContainer) {
//                 container.classList.remove('is-loading');
//                 return;
//               }
//               var newSortDialog = temp.querySelector('#sortDrawer-' + this.sectionId);
//               if (newSortDialog) {
//                 var oldSortDialog = document.getElementById('sortDrawer-' + this.sectionId);
//                 if (oldSortDialog && oldSortDialog.parentNode) {
//                   oldSortDialog.parentNode.replaceChild(newSortDialog, oldSortDialog);
//                 }
//               }
//               // Update inner parts in the main container
//               this.replaceInner('[data-collection-toolbar]', container, newContainer);
//               this.replaceInner('[data-collection-filters]', container, newContainer);
//               this.replaceInner('[data-collection-products]', container, newContainer);
//               this.replaceInner('[data-collection-pagination]', container, newContainer);
//               this.replaceInner('[data-load-more]', container, newContainer);
//               document.querySelector('.utility-grid')?.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//               });

//               // 🔥 NEW: replace existing dialog in DOM with updated dialog from section
//               if (newDialog) {
//                 var oldDialog = this.getDialog();
//                 if (oldDialog && oldDialog.parentNode) {
//                   oldDialog.parentNode.replaceChild(newDialog, oldDialog);
//                 }
//               }

//               if (this.sectionId) {
//                 searchParams.delete('section_id');
//               }
//               var finalUrl = window.location.pathname;
//               var qs = searchParams.toString();
//               if (qs) finalUrl += '?' + qs;
//               window.history.replaceState({}, '', finalUrl);

//               // Re-bind everything on updated DOM (including fresh dialog)
//               this.bindAll();
//               container.classList.remove('is-loading');
//             }.bind(this)
//           )
//           .catch(function (error) {
//             if (error && error.name === 'AbortError') return;
//             container.classList.remove('is-loading');
//           });
//       };

//       CollectionFacetsRoot.prototype.replaceInner = function (selector, oldRoot, newRoot) {
//         var oldEl = oldRoot.querySelector(selector);
//         var newEl = newRoot.querySelector(selector);
//         if (oldEl && newEl) {
//           oldEl.innerHTML = newEl.innerHTML;
//           if(oldEl.classList.contains('display-none')){
//             oldEl.classList.remove('display-none')
//           }
//         }
//         if ((selector === '[data-collection-pagination]' ||
//             selector === '[data-load-more]') &&
//             oldEl &&
//             !newEl
//           ) {
//             oldEl.innerHTML = '';
//           }
//       };

//       // ---------- Price range (noUiSlider) ----------

//       CollectionFacetsRoot.prototype.initPriceRanges = function () {
//         if (!window.noUiSlider) return;

//         var forms = this.getFilterForms();
//         if (!forms.length) return;

//         for (var i = 0; i < forms.length; i++) {
//           var ranges = forms[i].querySelectorAll('[data-price-range]');
//           for (var j = 0; j < ranges.length; j++) {
//             this.initSinglePriceRange(ranges[j]);
//           }
//         }
//       };

//       CollectionFacetsRoot.prototype.initSinglePriceRange = function (container) {
//         var self = this;
//         container._priceTouched = false;
//         var sliderEl = container.querySelector('[data-price-slider]');
//         var minInput = container.querySelector('.input-price-min');
//         var maxInput = container.querySelector('.input-price-max');

//         if (!sliderEl || !minInput || !maxInput) return;
//         if (sliderEl.noUiSlider) return;

//         var dataMin = parseFloat(container.getAttribute('data-min')) || 0;
//         var dataMax = parseFloat(container.getAttribute('data-max')) || 0;
//         var currentMin = parseFloat(container.getAttribute('data-current-min'));
//         var currentMax = parseFloat(container.getAttribute('data-current-max'));

//         if (isNaN(currentMin)) currentMin = dataMin;
//         if (isNaN(currentMax)) currentMax = dataMax;

//         if (currentMin < dataMin) currentMin = dataMin;
//         if (currentMax > dataMax) currentMax = dataMax;
//         if (currentMin > currentMax) currentMin = currentMax;

//         noUiSlider.create(sliderEl, {
//           start: [currentMin, currentMax],
//           connect: true,
//           range: {
//             min: dataMin,
//             max: dataMax
//           },
//           step: 1
//         });

//         // slider -> inputs
//         sliderEl.noUiSlider.on('update', function (values) {
//           var minVal = Math.round(values[0]);
//           var maxVal = Math.round(values[1]);
          
//           // always show concrete numbers (including full max)
//           minInput.value = minVal;
//           maxInput.value = maxVal;
//         });

//         // slider -> apply on change (respect layout rules)
//         sliderEl.noUiSlider.on('change', function () {
//           container._priceTouched = true;
//           self.syncPriceRangeInputs(container);
//           self.handlePriceFilterChanged();
//         });

//         // inputs -> slider
//         function setSliderFromInputs(apply) {
//           var minVal = parseFloat(minInput.value);
//           var maxVal = parseFloat(maxInput.value);

//           if (isNaN(minVal)) minVal = dataMin;
//           if (isNaN(maxVal)) maxVal = dataMax;

//           if (minVal < dataMin) minVal = dataMin;
//           if (maxVal > dataMax) maxVal = dataMax;
//           if (minVal > maxVal) minVal = maxVal;

//           sliderEl.noUiSlider.set([minVal, maxVal]);
//           self.syncPriceRangeInputs(container);

//           if (apply) {
//             self.handlePriceFilterChanged();
//           }
//         }

//         minInput.addEventListener('change', function () {
//           container._priceTouched = true;
//           setSliderFromInputs(true);
//         });
//         maxInput.addEventListener('change', function () {
//           container._priceTouched = true;
//           setSliderFromInputs(true);
//         });
//       };

//       CollectionFacetsRoot.prototype.handlePriceFilterChanged = function () {
//         var horizontal = this.isHorizontalFiltersActive();

//         if (horizontal || isMobile()) {
//           // Only enable submit button(s); no immediate apply
//           var forms = this.getFilterForms();
//           for (var i = 0; i < forms.length; i++) {
//             var btn = forms[i].querySelector('button[type="submit"]');
//             if (btn) {
//               btn.disabled = false;
//               btn.classList.add('facets-submit-active');
//             }
//           }
//         } else {
//           // Desktop, non-horizontal -> auto-apply
//           this.updateCollectionFromState();
//         }
//       };

//       // ---------- Horizontal filters (buttons that open dialog) ----------

//       CollectionFacetsRoot.prototype.bindHorizontalFilterTriggers = function () {
//         var container = this.getContainer();
//         if (!container) return;

//         var triggers = container.querySelectorAll('[data-filter-dialog]');
//         if (!triggers.length) return;

//         for (var i = 0; i < triggers.length; i++) {
//           var btn = triggers[i];
//           if (btn.getAttribute('data-filter-dialog-bound') === 'true') continue;
//           btn.setAttribute('data-filter-dialog-bound', 'true');
//           btn.addEventListener('click', this.onHorizontalTriggerClickHandler);
//         }
//       };

//       CollectionFacetsRoot.prototype.onHorizontalTriggerClick = function (event) {
//         this.preventEvent(event);

//         var trigger = event.currentTarget;
//         var dialogId = trigger.getAttribute('data-filter-dialog');
//         var headingId = trigger.getAttribute('data-tab-heading');
//         if (!dialogId) return;

//         var dialog = document.getElementById(dialogId);
//         if (!dialog) return;

//         // Open dialog
//         this.openDialog(dialog,trigger);

//         // Ensure tabs / close / clear / drag handlers are bound for this dialog
//         this.bindDialogTabs(dialog);
//         this.bindDialogClose(dialog);
//         this.bindMobileClearFilters(dialog);
//         this.bindMobileDragToClose(dialog);
//         if (!isMobile()) {
//           // Activate corresponding tab + panel
//           if (headingId) {
//             var targetTab = dialog.querySelector('#' + headingId);
//             if (targetTab) {
//               this.activateDialogTab(targetTab, dialog);
//               return;
//             }
//           }

//           // Fallback: activate first tab
//           var firstTab = dialog.querySelector('.filter-dl-tabs span[data-target]');
//           if (firstTab) {
//             this.activateDialogTab(firstTab, dialog);
//           }
//         }
//         else{
//           var panels = dialog.querySelectorAll('.filter-dl-panel');
//           var tabs = dialog.querySelectorAll('.filter-dl-tabs span');

//           for (var i = 0; i < panels.length; i++) {
//             panels[i].classList.remove('is-active');
//           }

//           for (var j = 0; j < tabs.length; j++) {
//             tabs[j].classList.remove('is-active');
//           }

//           return;
//         }
//       };

//       // ---------- Dialog tabs ----------

//       CollectionFacetsRoot.prototype.bindDialogTabs = function (dialog) {
//         dialog = dialog || this.getDialog();
//         if (!dialog) return;

//         var tabs = dialog.querySelectorAll('.filter-dl-tabs span[data-target]');

//         for (var i = 0; i < tabs.length; i++) {
//           var tab = tabs[i];

//           tab.setAttribute('role', 'tab');
//           tab.setAttribute('aria-selected', tab.classList.contains('is-active') ? 'true' : 'false');

//           var panelId = tab.getAttribute('data-target');
//           if (panelId) {
//             tab.setAttribute('aria-controls', panelId);
//           }

//           if (tab.getAttribute('data-tab-bound') !== 'true') {
//             tab.setAttribute('data-tab-bound', 'true');
//             tab.addEventListener('click', this.onDialogTabClickHandler);
//             tab.addEventListener('keydown', this.onDialogTabKeydown.bind(this));
//           }
//         }

//         var tabList = dialog.querySelector('.filter-dl-tabs');
//         if (tabList) {
//           tabList.setAttribute('role', 'tablist');
//         }
//       };

//       CollectionFacetsRoot.prototype.onDialogTabClick = function (event) {
//         this.preventEvent(event);

//         var tab = event.currentTarget;
//         if (!tab) return;

//         var dialog = tab.closest('dialog');
//         if (!dialog) {
//           dialog = this.getDialog();
//         }
//         if (!dialog) return;

//         this.activateDialogTab(tab, dialog);
//       };

//       CollectionFacetsRoot.prototype.activateDialogTab = function (tab, dialog) {
//         if (!dialog || !tab) return;

//         var targetId = tab.getAttribute('data-target');
//         var allTabs = dialog.querySelectorAll('.filter-dl-tabs span[data-target]');
//         var allPanels = dialog.querySelectorAll('.filter-dl-panel');

//         for (var i = 0; i < allTabs.length; i++) {
//           allTabs[i].classList.remove('is-active');
//           allTabs[i].setAttribute('aria-selected', 'false');
//           allTabs[i].setAttribute('tabindex', '-1');
//         }

//         for (var j = 0; j < allPanels.length; j++) {
//           allPanels[j].classList.remove('is-active');
//           allPanels[j].setAttribute('hidden', 'hidden');
//         }

//         tab.classList.add('is-active');
//         tab.setAttribute('aria-selected', 'true');
//         tab.setAttribute('tabindex', '0');

//         if (targetId) {
//           var panel = dialog.querySelector('#' + targetId);
//           if (panel) {
//             panel.classList.add('is-active');
//             panel.removeAttribute('hidden');
//             panel.setAttribute('role', 'tabpanel');
//             panel.setAttribute('aria-labelledby', tab.id);
//           }
//         }
//       };
//       CollectionFacetsRoot.prototype.onDialogTabKeydown = function (event) {
//         var key = event.key || event.keyCode;
//         var currentTab = event.currentTarget;
//         var dialog = currentTab.closest('dialog');

//         if (!dialog) return;

//         var tabs = dialog.querySelectorAll('.filter-dl-tabs span[data-target]');
//         if (!tabs.length) return;

//         var currentIndex = -1;

//         for (var i = 0; i < tabs.length; i++) {
//           if (tabs[i] === currentTab) {
//             currentIndex = i;
//             break;
//           }
//         }

//         if (currentIndex === -1) return;

//         var nextIndex = currentIndex;

//         if (key === 'ArrowRight' || key === 'ArrowDown' || key === 39 || key === 40) {
//           event.preventDefault();
//           nextIndex = currentIndex + 1;
//           if (nextIndex >= tabs.length) nextIndex = 0;

//           tabs[nextIndex].focus();
//           this.activateDialogTab(tabs[nextIndex], dialog);
//           return;
//         }

//         if (key === 'ArrowLeft' || key === 'ArrowUp' || key === 37 || key === 38) {
//           event.preventDefault();
//           nextIndex = currentIndex - 1;
//           if (nextIndex < 0) nextIndex = tabs.length - 1;

//           tabs[nextIndex].focus();
//           this.activateDialogTab(tabs[nextIndex], dialog);
//           return;
//         }

//         if (key === 'Home' || key === 36) {
//           event.preventDefault();
//           tabs[0].focus();
//           this.activateDialogTab(tabs[0], dialog);
//           return;
//         }

//         if (key === 'End' || key === 35) {
//           event.preventDefault();
//           tabs[tabs.length - 1].focus();
//           this.activateDialogTab(tabs[tabs.length - 1], dialog);
//           return;
//         }

//         if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32) {
//           event.preventDefault();
//           this.activateDialogTab(currentTab, dialog);
//         }
//       };
//       // ---------- Dialog open/close helpers ----------

//       CollectionFacetsRoot.prototype.openDialog = function (dialog) {
//         if (!dialog) return;

//         if (dialog.showModal) {
//           dialog.showModal();
//         } else {
//           dialog.setAttribute('open', 'open');
//         }

//         dialog.classList.add('is-active');
//         this.lockBodyScroll();

//         if (window.FocusTrap) {
//           var self = this;
//           var initialFocus =
//             dialog.querySelector('.dialog-close') ||
//             dialog.querySelector('[data-filter-dl-header]') ||
//             dialog.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

//           window.FocusTrap.trap(
//             dialog,
//             initialFocus,
//             this._handleDialogEsc.bind(this, dialog)
//           );
//         }
//       };

//       CollectionFacetsRoot.prototype.closeDialog = function (dialog) {
//         if (!dialog) return;

//         if (window.FocusTrap) {
//           window.FocusTrap.release(dialog);
//         }

//         if (dialog.close) {
//           dialog.close();
//         } else {
//           dialog.removeAttribute('open');
//         }

//         dialog.classList.remove('is-active');
//         this.unlockBodyScroll();
//       };

//       CollectionFacetsRoot.prototype._handleDialogEsc = function (dialog) {
//         if (!dialog) return;
//         if (window.FocusTrap) {
//           window.FocusTrap.release(dialog);
//         }
//         if (isMobile()) {
//           this.closeDialogWithSlide(dialog);
//         } else {
//           this.closeDialog(dialog);
//         }
//       };

//       CollectionFacetsRoot.prototype.activateDefaultDialogTab = function (dialog) {
//         if (!dialog) return;

//         var activeTab = dialog.querySelector('.filter-dl-tabs span[data-target].is-active');

//         if (!activeTab) {
//           activeTab = dialog.querySelector('.filter-dl-tabs span[data-target]');
//         }

//         if (activeTab) {
//           this.activateDialogTab(activeTab, dialog);
//         }
//       };
      
//       CollectionFacetsRoot.prototype.closeDialogWithSlide = function (dialog) {
//         if (!dialog) {
//           dialog = this.getDialog();
//         }
//         if (!dialog) return;

//         if (!isMobile()) {
//           this.closeDialog(dialog);
//           return;
//         }

//         var panel = dialog.querySelector('.dialog-inner');
//         var bgLayer = dialog.querySelector('.dialog-bg-layer');

//         if (!panel) {
//           this.closeDialog(dialog);
//           return;
//         }

//         panel.style.transition = 'transform 0.25s ease-out';
//         panel.style.transform = 'translateY(100%)';

//         if (bgLayer) {
//           bgLayer.style.transition = 'opacity 0.25s ease-out';
//           bgLayer.style.opacity = '0';
//         }

//         var self = this;
//         window.setTimeout(function () {
//           panel.style.transform = '';
//           panel.style.transition = '';
//           if (bgLayer) {
//             bgLayer.style.opacity = '';
//             bgLayer.style.transition = '';
//           }
//           self.closeDialog(dialog);
//         }, 250);
//       };

//       // ---------- Dialog close + mobile clear filters ----------

//       CollectionFacetsRoot.prototype.bindDialogClose = function (dialog) {
//         dialog = dialog || this.getDialog();
//         if (!dialog) return;

//         var closeBtn = dialog.querySelector('.dialog-close');
//         var bgLayer = dialog.querySelector('.dialog-bg-layer');
//         var self = this;

//         function bindClose(el) {
//           if (!el) return;
//           if (el.getAttribute('data-dialog-close-bound') === 'true') return;
//           el.setAttribute('data-dialog-close-bound', 'true');
//           el.addEventListener('click', function () {
//             // On mobile, use slide-down; on desktop, normal close
//             if (isMobile()) {
//               self.closeDialogWithSlide(dialog);
//             } else {
//               self.closeDialog(dialog);
//             }
//           });
//         }

//         bindClose(closeBtn);
//         bindClose(bgLayer);
//       };

//       CollectionFacetsRoot.prototype.bindMobileClearFilters = function (dialog) {
//         dialog = dialog || this.getDialog();
//         if (!dialog) return;

//         var clearLink = dialog.querySelector('[data-clear-filters]');
//         if (!clearLink) return;

//         var self = this;

//         if (clearLink.getAttribute('data-clear-bound') === 'true') return;
//         clearLink.setAttribute('data-clear-bound', 'true');

//         clearLink.addEventListener('click', function (event) {
//           self.preventEvent(event);

//           var href = clearLink.getAttribute('href') || window.location.pathname;
//           var params = createSearchParamsFromUrl(href);
//           self.fetchSection(params);

//           if (isMobile()) {
//             self.closeDialogWithSlide(dialog);
//           } else {
//             self.closeDialog(dialog);
//           }
//         });
//       };

//       CollectionFacetsRoot.prototype.syncFacetControlState = function (sourceControl) {
//         if (!sourceControl || !sourceControl.name) return;

//         var sourceType = (sourceControl.type || '').toLowerCase();
//         var sourceName = sourceControl.name;
//         var sourceValue = sourceControl.value;
//         var forms = this.getFilterForms();

//         for (var i = 0; i < forms.length; i++) {
//           var controls = forms[i].querySelectorAll('[name="' + sourceName + '"]');

//           for (var j = 0; j < controls.length; j++) {
//             var control = controls[j];
//             if (control === sourceControl) continue;

//             if (sourceType === 'checkbox') {
//               if (control.value === sourceValue) {
//                 control.checked = sourceControl.checked;
//               }
//               continue;
//             }

//             if (sourceType === 'radio') {
//               control.checked = control.value === sourceValue;
//               continue;
//             }

//             control.value = sourceValue;
//           }
//         }
//       };

//       CollectionFacetsRoot.prototype.syncPriceRangeInputs = function (sourceContainer) {
//         if (!sourceContainer) return;

//         var sourceMin = sourceContainer.querySelector('.input-price-min');
//         var sourceMax = sourceContainer.querySelector('.input-price-max');
//         var forms = this.getFilterForms();

//         for (var i = 0; i < forms.length; i++) {
//           var container = forms[i].querySelector('[data-price-range]');
//           if (!container || container === sourceContainer) continue;

//           var minInput = container.querySelector('.input-price-min');
//           var maxInput = container.querySelector('.input-price-max');

//           if (minInput && sourceMin) {
//             minInput.value = sourceMin.value;
//           }

//           if (maxInput && sourceMax) {
//             maxInput.value = sourceMax.value;
//           }

//           container._priceTouched = sourceContainer._priceTouched === true;
//         }
//       };

//       CollectionFacetsRoot.prototype.syncActiveFilterCounts = function (name) {
//         if (!name || name.indexOf('filter.') !== 0) return;

//         var forms = this.getFilterForms();
//         for (var i = 0; i < forms.length; i++) {
//           var input = forms[i].querySelector('input[name="' + name + '"]');
//           if (!input) continue;

//           this.updateActiveFilterCount(forms[i], input);
//         }
//       };

//       CollectionFacetsRoot.prototype.updateActiveFilterCount = function (form, input) {
//         if (!form || !input) return;

//         var name = input.name;
//         if (!name || name.indexOf('filter.') !== 0) return;

//         // get all inputs of same filter group
//         var inputs = form.querySelectorAll('input[name="' + name + '"]');

//         var count = 0;
//         for (var i = 0; i < inputs.length; i++) {
//           if (inputs[i].checked) count++;
//         }

//         // find wrapper
//         var wrapper = input.closest('[data-dialog-filter-wrapper], .utility-group');
//         if (!wrapper) return;

//         var counter = wrapper.querySelector('[data-active-values-count]');
//         if (!counter) return;

//         counter.textContent = '(' + count + ')';

//         if (count === 0) {
//           counter.classList.add('display-none');
//         } else {
//           counter.classList.remove('display-none');
//         }
//       };

//       // ---------- Mobile drag to close ----------

//       CollectionFacetsRoot.prototype.bindMobileDragToClose = function (dialog) {
//         dialog = dialog || this.getDialog();
//         if (!dialog) return;
//         if (!isMobile()) return;

//         var dragHandle = dialog.querySelector('[data-drawer-drag-handle]');
//         var panel = dialog.querySelector('.dialog-inner');
//         var bgLayer = dialog.querySelector('.dialog-bg-layer');
//         var self = this;

//         if (!dragHandle || !panel) return;
//         if (dragHandle.getAttribute('data-drag-bound') === 'true') return;
//         dragHandle.setAttribute('data-drag-bound', 'true');

//         var startY = 0;
//         var currentY = 0;
//         var dragging = false;
//         var threshold = 80;

//         function onTouchStart(e) {
//           if (!e.touches || !e.touches.length) return;
//           dragging = true;
//           startY = e.touches[0].clientY;
//           currentY = startY;
//           panel.style.transition = 'none';
//           if (bgLayer) {
//             bgLayer.style.transition = 'none';
//           }
//         }

//         function onTouchMove(e) {
//           if (!dragging || !e.touches || !e.touches.length) return;
//           currentY = e.touches[0].clientY;
//           var deltaY = currentY - startY;
//           if (deltaY < 0) deltaY = 0;

//           panel.style.transform = 'translateY(' + deltaY + 'px)';

//           if (bgLayer) {
//             var opacity = Math.max(0, 1 - deltaY / 300);
//             bgLayer.style.opacity = String(opacity);
//           }
//         }

//         function onTouchEnd() {
//           if (!dragging) return;
//           dragging = false;

//           var deltaY = currentY - startY;

//           panel.style.transition = 'transform 0.25s ease-out';
//           if (bgLayer) {
//             bgLayer.style.transition = 'opacity 0.25s ease-out';
//           }

//           if (deltaY > threshold) {
//             // slide down & close
//             panel.style.transform = 'translateY(100%)';
//             if (bgLayer) {
//               bgLayer.style.opacity = '0';
//             }
//             window.setTimeout(function () {
//               panel.style.transform = '';
//               panel.style.transition = '';
//               if (bgLayer) {
//                 bgLayer.style.opacity = '';
//                 bgLayer.style.transition = '';
//               }
//               self.closeDialog(dialog);
//             }, 250);
//           } else {
//             // snap back
//             panel.style.transform = 'translateY(0px)';
//             if (bgLayer) {
//               bgLayer.style.opacity = '';
//             }
//             window.setTimeout(function () {
//               panel.style.transition = '';
//               if (bgLayer) {
//                 bgLayer.style.transition = '';
//               }
//             }, 250);
//           }
//         }

//         dragHandle.addEventListener('touchstart', onTouchStart, { passive: true });
//         dragHandle.addEventListener('touchmove', onTouchMove, { passive: true });
//         dragHandle.addEventListener('touchend', onTouchEnd);
//         dragHandle.addEventListener('touchcancel', onTouchEnd);
//       };

//       // ---------- Utils ----------

//       CollectionFacetsRoot.prototype.preventEvent = function (event) {
//         if (!event) return;
//         if (event.preventDefault) event.preventDefault();
//         event.returnValue = false;
//       };

//       CollectionFacetsRoot.prototype.bindSortDialogTriggers = function () {
//         var triggers = document.querySelectorAll('[data-sort-dialog]');
//         if (!triggers.length) return;

//         for (var i = 0; i < triggers.length; i++) {
//           var btn = triggers[i];

//           if (btn.getAttribute('data-sort-dialog-bound') === 'true') continue;
//           btn.setAttribute('data-sort-dialog-bound', 'true');

//           btn.addEventListener('click', this.onSortDialogTriggerClickHandler);
//         }
//       };

//       CollectionFacetsRoot.prototype.onSortDialogTriggerClick = function (event) {
//         this.preventEvent(event);

//         var btn = event.currentTarget;
//         var dialogId = btn.getAttribute('data-sort-dialog');
//         if (!dialogId) return;

//         var dialog = document.getElementById(dialogId);
//         if (!dialog) return;

//         this.openDialog(dialog,btn);
//         this.bindDialogClose(dialog);
//         this.bindMobileDragToClose(dialog);

//         // bind sort radios inside dialog
//         this.bindSortDialogOptions(dialog);
//       };

//       CollectionFacetsRoot.prototype.bindSortDialogOptions = function (dialog) {
//         var inputs = dialog.querySelectorAll('input[name="sort_by"]');

//         for (var i = 0; i < inputs.length; i++) {
//           var input = inputs[i];

//           if (input.getAttribute('data-sort-bound') === 'true') continue;
//           input.setAttribute('data-sort-bound', 'true');

//           var self = this;

//           input.addEventListener('change', function () {
//             // apply instantly
//             self.updateCollectionFromState();

//             // close dialog
//             if (isMobile()) {
//               self.closeDialogWithSlide(dialog);
//             } else {
//               self.closeDialog(dialog);
//             }
//           });
//         }
//       };

//       CollectionFacetsRoot.prototype.getActiveSortValue = function () {
//         // 1. Check open sort dialog first
//         if (this.sectionId) {
//           var dialog = document.getElementById('sortDrawer-' + this.sectionId);
//           if (dialog && dialog.classList.contains('is-active')) {
//             var dlgChecked = dialog.querySelector('input[name="sort_by"]:checked');
//             if (dlgChecked && dlgChecked.value) {
//               return dlgChecked.value;
//             }
//           }
//         }

//         // 2. Fallback to desktop sort (inside container)
//         var container = this.getContainer();
//         if (container) {
//           var desktopChecked = container.querySelector(
//             '.utility-select-option input[name="sort_by"]:checked'
//           );
//           if (desktopChecked && desktopChecked.value) {
//             return desktopChecked.value;
//           }
//         }

//         return null;
//       };

//       CollectionFacetsRoot.prototype.lockBodyScroll = function () {
//         document.body.classList.add('overflow-hide');
//       };

//       CollectionFacetsRoot.prototype.unlockBodyScroll = function () {
//         // Only unlock if NO dialogs are open
//         var openDialogs = document.querySelectorAll('dialog.is-active,dialog.is-open,.dialog.is-active,.dialog.is-open');
//         if (openDialogs.length === 0) {
//           document.body.classList.remove('overflow-hide');
//         }
//       };

//       CollectionFacetsRoot.prototype.bindMobilePanelClose = function () {
//         if (!isMobile()) return;

//         var elements = document.querySelectorAll('[data-dl-panel-close]');
//         if (!elements.length) return;

//         for (var i = 0; i < elements.length; i++) {
//           var el = elements[i];

//           if (el.getAttribute('data-dl-panel-close-bound') === 'true') continue;
//           el.setAttribute('data-dl-panel-close-bound', 'true');

//           el.addEventListener('click', function () {
//             var panel = this.closest('.filter-dl-panel');
//             if (!panel) return;

//             panel.classList.remove('is-active');
//           });
//         }
//       };
//       CollectionFacetsRoot.prototype.bindResizeWatcher = function () {
//         var self = this;

//         if (this._resizeBound) return;
//         this._resizeBound = true;

//         window.addEventListener('resize', function () {
//           if (!isMobile()) {
//             self.closeAllDialogs();
//           }
//         });
//       };
//       CollectionFacetsRoot.prototype.closeAllDialogs = function () {
//         var dialogs = document.querySelectorAll('.filter-dialog.is-active');

//         for (var i = 0; i < dialogs.length; i++) {
//           this.closeDialog(dialogs[i]);
//         }
//       };
//       return CollectionFacetsRoot;
//     })();

//     customElements.define('collection-facets-root', CollectionFacetsRoot);
//   }
  





// document.addEventListener('click', async function (e) {
//       const button = e.target.closest('.load-more-btn');
//       if (!button) return;

//       e.preventDefault();

//       const page = Number(button.dataset.nextPage);
//       const sectionId = button.closest('.shopify-section').id.replace('shopify-section-', '');

//       // Preserve all current filters & sorting
//       const url = new URL(window.location.href);
//       url.searchParams.set('page', page);
//       url.searchParams.set('section_id', sectionId);

//       button.disabled = true;

//       const response = await fetch(url.toString());
//       const html = await response.text();
//       const doc = new DOMParser().parseFromString(html, 'text/html');

//       // Append products
//       const newProducts = doc.querySelector('[data-collection-products]');
//       const currentProducts = document.querySelector('[data-collection-products]');

//       if (newProducts && currentProducts) {
//         currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
//       }

//       const newLoadMore = doc.querySelector('[data-load-more]');
//       const currentLoadMore = document.querySelector('[data-load-more]');

//       if (newLoadMore && currentLoadMore) {
//         currentLoadMore.innerHTML = newLoadMore.innerHTML;
//       }
//     });
// })();
(function () {
  if (window.customElements && !customElements.get('collection-facets-root')) {
    var MOBILE_MAX_WIDTH = 991;
    function isMobile() {
      return window.innerWidth <= MOBILE_MAX_WIDTH;
    }
    function createSearchParamsFromUrl(url) {
      try {
        var u = new URL(url, window.location.origin);
        return new URLSearchParams(u.search);
      } catch (e) {
        return new URLSearchParams();
      }
    }
    var CollectionFacetsRoot = (function () {
      function CollectionFacetsRoot() {
        var self = Reflect.construct(HTMLElement, [], CollectionFacetsRoot);
        self._initialized = false;
        self.sectionId = '';
        self.abortController = null;
        self.onFacetChangeHandler = function (event) {
          self.onFacetChange(event);
        };
        self.onFacetFormSubmitHandler = function (event) {
          self.onFacetFormSubmit(event);
        };
        self.onPaginationClickHandler = function (event) {
          self.onPaginationClick(event);
        };
        self.onFilterLinkClickHandler = function (event) {
          self.onFilterLinkClick(event);
        };
        self.onSortChangeHandler = function (event) {
          self.onSortChange(event);
        };
        self.onDialogTabClickHandler = function (event) {
          self.onDialogTabClick(event);
        };
        self.onHorizontalTriggerClickHandler = function (event) {
          self.onHorizontalTriggerClick(event);
        };
        self.onSortDialogTriggerClickHandler = function (event) {
          self.onSortDialogTriggerClick(event);
        };
        return self;
      }
      CollectionFacetsRoot.prototype = Object.create(HTMLElement.prototype);
      CollectionFacetsRoot.prototype.constructor = CollectionFacetsRoot;
      CollectionFacetsRoot.prototype.connectedCallback = function () {
        if (this._initialized) return;
        this._initialized = true;
        this.sectionId = this.getAttribute('data-section-id') || '';
        this.bindAll();
        this.bindResizeWatcher();
      };
      // HELPERS
      CollectionFacetsRoot.prototype.getContainer = function () {
        return this.querySelector('.main-collection-contain');
      };
      CollectionFacetsRoot.prototype.getDialog = function () {
        if (!this.sectionId) return null;
        return document.getElementById(
          'filterTabDrawer-' + this.sectionId
        );
      };
      /*
       * Returns desktop + dialog forms.
       * Used only for synchronising controls / initialisation.
       * IMPORTANT:
       * We DO NOT use this list anymore when submitting filters.
       * Filter submission now uses one exact form.*/
      CollectionFacetsRoot.prototype.getFilterForms = function () {
        var list = [];
        var inside = this.querySelectorAll(
          'form.facets-filter-form[data-facets-form]'
        );
        for (var i = 0; i < inside.length; i++) {
          list.push(inside[i]);
        }
        var dialog = this.getDialog();
        if (dialog) {
          var dlgForms = dialog.querySelectorAll(
            'form.facets-filter-form[data-facets-form]'
          );
          for (var j = 0; j < dlgForms.length; j++) {
            list.push(dlgForms[j]);
          }
        }
        return list;
      };
      /* DESKTOP FILTER FORM*/
      CollectionFacetsRoot.prototype.getDesktopFilterForm = function () {
        var container = this.getContainer();
        if (!container) {
          return null;
        }
        return container.querySelector(
          'form.facets-filter-form[data-facets-form]'
        );
      };
      /*MOBILE FILTER FORM This is the important part. Mobile Apply will ONLY use this form.*/
      CollectionFacetsRoot.prototype.getMobileFilterForm = function () {
        var dialog = this.getDialog();
        if (!dialog) {
          return null;
        }
        return dialog.querySelector(
          'form.facets-filter-form[data-facets-form]'
        );
      };
      CollectionFacetsRoot.prototype.isHorizontalFiltersActive = function () {
        var container = this.getContainer();
        if (!container) return false;
        return !!container.querySelector('.horizontal-filters');
      };
      CollectionFacetsRoot.prototype.bindAll = function () {
        this.bindFacetEvents();
        this.bindPaginationLinks();
        this.bindFilterChips();
        this.bindSortControls();
        this.initPriceRanges();
        this.bindHorizontalFilterTriggers();
        this.bindDialogTabs();
        this.bindDialogClose();
        this.bindMobileClearFilters();
        this.bindMobileDragToClose();
        this.bindSortDialogTriggers();
        this.bindMobilePanelClose();
        /* IMPORTANT:Directly bind mobile Apply buttons.*/
        this.bindMobileApplyButtons();
      };
      // FACET INPUTS
      CollectionFacetsRoot.prototype.bindFacetEvents = function () {
        var forms = this.getFilterForms();
        for (var i = 0; i < forms.length; i++) {
          var form = forms[i];
          if (
            form.getAttribute('data-facets-events-bound') === 'true'
          ) {
            continue;
          }
          form.setAttribute(
            'data-facets-events-bound',
            'true'
          );
          form.addEventListener(
            'submit',
            this.onFacetFormSubmitHandler
          );
          var inputs = form.querySelectorAll(
            'input[name^="filter."], select[name^="filter."]'
          );
          for (var j = 0; j < inputs.length; j++) {
            inputs[j].addEventListener(
              'change',
              this.onFacetChangeHandler
            );
          }
        }
      };
      CollectionFacetsRoot.prototype.onFacetChange = function (event) {
        var target = event.target || event.srcElement;
        if (!target) return;
        var form = target.form;
        if (!form) return;
        /* Keep desktop/mobile UI controls synchronized.*/
        this.syncFacetControlState(target);
        this.syncActiveFilterCounts(target.name);
        if (
          target.classList &&
          (
            target.classList.contains('input-price-min') ||
            target.classList.contains('input-price-max')
          )
        ) {
          return;
        }
        var horizontal = this.isHorizontalFiltersActive();
        if (isMobile()) {
          var mobileBtn = form.querySelector(
            'button[type="submit"], input[type="submit"]'
          );
          if (mobileBtn) {
            mobileBtn.disabled = false;
            mobileBtn.classList.add(
              'facets-submit-active'
            );
          }
          return;
        }
        /*HORIZONTAL DESKTOP Do not apply immediately.*/
        if (horizontal) {
          var submitBtn = form.querySelector(
            'button[type="submit"], input[type="submit"]'
          );
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.add(
              'facets-submit-active'
            );
          }
          return;
        }
        /* IMPORTAN Only use the desktop form. */
        this.preventEvent(event);
        this.updateCollectionFromState(form);
      };
      // MOBILE APPLY BUTTON
      CollectionFacetsRoot.prototype.bindMobileApplyButtons = function () {
        var dialog = this.getDialog();
        if (!dialog) return;
        var self = this;
        var buttons = dialog.querySelectorAll(
          'button[type="submit"], input[type="submit"], [data-filter-submit]'
        );
        if (!buttons.length) {
          return;
        }
        for (var i = 0; i < buttons.length; i++) {
          var button = buttons[i];
          if (
            button.getAttribute(
              'data-mobile-apply-bound'
            ) === 'true'
          ) {
            continue;
          }
          button.setAttribute(
            'data-mobile-apply-bound','true'
          );
          button.addEventListener('click', function (event) {
            /*This handler is specifically for mobile.*/
            if (!isMobile()) {
              return;
            }
            self.preventEvent(event);
            /*Get the exact form that contains the clicked Apply button.*/
            var form = this.closest(
              'form.facets-filter-form[data-facets-form]'
            );
            /*Fallback to the mobile dialog form.*/
            if (!form) {
              form = self.getMobileFilterForm();
            }
            if (!form) {
              console.log('Mobile filter form not found');
              return;
            }
            /* APPLY ONLY THIS FORM.*/
            self.updateCollectionFromState(form);
            /* Close mobile drawer. */
            var currentDialog = self.getDialog();
            if (currentDialog) {
              self.closeDialog(currentDialog);
            }
          });
        }
      };
      // FORM SUBMIT
      CollectionFacetsRoot.prototype.onFacetFormSubmit = function (event) {
        this.preventEvent(event);
        var form = event.target || event.srcElement;
        if (!form) {
          if (isMobile()) {
            form = this.getMobileFilterForm();
          } else {
            form = this.getDesktopFilterForm();
          }
        }
        if (!form) {
          console.log('Filter submit form not found');
          return;
        }
        var dialog = form.closest('dialog');
        if (dialog) {
          this.closeDialog(dialog);
        }
        this.updateCollectionFromState(form);
      };
      // SORT CONTROLS
      CollectionFacetsRoot.prototype.bindSortControls = function () {
        var container = this.getContainer();
        if (!container) return;
        var sortInputs = container.querySelectorAll(
          '.utility-select-option input[name="sort_by"]'
        );
        for (var i = 0; i < sortInputs.length; i++) {
          sortInputs[i].addEventListener(
            'change',
            this.onSortChangeHandler
          );
        }
      };
      CollectionFacetsRoot.prototype.onSortChange = function (event) {
        this.preventEvent(event);
        /* Sorting should preserve currently applied desktop filters.*/
        this.updateCollectionFromState(
          this.getDesktopFilterForm()
        );
      };
      // PAGINATION
      CollectionFacetsRoot.prototype.bindPaginationLinks = function () {
        var container = this.getContainer();
        if (!container) return;
        var paginationRoot = container.querySelector(
          '[data-collection-pagination]'
        );
        if (!paginationRoot) return;
        var links = paginationRoot.querySelectorAll(
          'a[href]'
        );
        for (var i = 0; i < links.length; i++) {
          if (
            links[i].getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {
            continue;
          }
          links[i].addEventListener(
            'click',
            this.onPaginationClickHandler
          );
        }
      };
      CollectionFacetsRoot.prototype.onPaginationClick = function (event) {
        this.preventEvent(event);
        var href = event.currentTarget.getAttribute('href');
        if (!href) return;
        var params = createSearchParamsFromUrl(href);
        this.fetchSection(params);
      };
      // FILTER CHIPS
      CollectionFacetsRoot.prototype.bindFilterChips = function () {
        var container = this.getContainer();
        if (!container) return;
        var links = container.querySelectorAll(
          '.utility-apply-facet a[href], .utility-apply-clear a[href]'
        );
        for (var i = 0; i < links.length; i++) {
          links[i].addEventListener(
            'click',
            this.onFilterLinkClickHandler
          );
        }
      };
      CollectionFacetsRoot.prototype.onFilterLinkClick = function (event) {
        this.preventEvent(event);
        var href = event.currentTarget.getAttribute(
          'href'
        );
        if (!href || href === '#') {
          href = window.location.pathname;
        }
        var params = createSearchParamsFromUrl(href);
        this.fetchSection(params);
      };
      // BUILD FILTER PARAMS
      CollectionFacetsRoot.prototype.updateCollectionFromState = function (
        sourceForm
      ) {
        var currentParams = new URLSearchParams(
          window.location.search
        );
        var newParams = new URLSearchParams();
        var seenFilterValues =
          Object.create(null);
        currentParams.forEach(function (value, key) {
          if (key.indexOf('filter.') === 0) {
            return;
          }
          if (key === 'page') {
            return;
          }
          if (key === 'sort_by') {
            return;
          }
          if (!newParams.has(key)) {
            newParams.set(key, value);
          }
        });
        /*Use supplied form. If no form supplied, desktop form is used.*/
        var form =
          sourceForm ||
          this.getDesktopFilterForm();
        if (!form) {
          console.log(
            'No filter form found'
          );
          return;
        }
        /** PRICE STATE*/
        var priceContainer =
          form.querySelector(
            '[data-price-range]'
          );
        var priceTouched = !!(
          priceContainer &&
          priceContainer._priceTouched === true
        );
        /*  Check if price was already applied before this interaction.*/
        var existingPriceMin =
          currentParams.get(
            'filter.v.price.gte'
          );
        var existingPriceMax =
          currentParams.get(
            'filter.v.price.lte'
          );
        var existingPriceApplied =
          existingPriceMin !== null ||
          existingPriceMax !== null;
        var controls = form.querySelectorAll(
          'input[name^="filter."], select[name^="filter."]'
        );
        for (
          var i = 0;
          i < controls.length;
          i++
        ) {
          var control = controls[i];
          if (control.disabled) {
            continue;
          }
          var name = control.name;
          if (!name) {
            continue;
          }
          var type =
            (control.type || '').toLowerCase();
          /*CHECKBOX Only checked values are submitted.*/
          if (
            type === 'checkbox' &&
            !control.checked
          ) {
            continue;
          }
          /** RADIO Only selected value is submitted. */
          if (
            type === 'radio' &&
            !control.checked
          ) {
            continue;
          }
          /* PRICE */
          if (
            name === 'filter.v.price.gte' ||
            name === 'filter.v.price.lte'
          ) {
            /* If price was never touched andthere is no existing price filter,completely ignore price.*/
            if (
              !priceTouched &&
              !existingPriceApplied
            ) {
              continue;
            }
          }
          /* MULTI-SELECT*/
          if (
            control.tagName &&
            control.tagName.toLowerCase() ===
              'select' &&
            control.multiple
          ) {
            for (
              var j = 0;
              j < control.options.length;
              j++
            ) {
              var option =
                control.options[j];
              if (
                !option.selected ||
                option.value === ''
              ) {
                continue;
              }
              var multiKey =
                name +
                '\u0000' +
                option.value;
              if (
                seenFilterValues[multiKey]
              ) {
                continue;
              }
              seenFilterValues[multiKey] =
                true;
              newParams.append(
                name,
                option.value
              );
            }
            continue;
          }
          var value = control.value;
          if (
            value === null ||
            value === ''
          ) {
            continue;
          }
          /* * Prevent duplicate values when the same filter exists in multiple places.*/
          var dedupeKey =
            name +
            '\u0000' +
            value;
          if (
            seenFilterValues[dedupeKey]
          ) {
            continue;
          }
          seenFilterValues[dedupeKey] =
            true;
          newParams.append(
            name,
            value
          );
        }
        /* PRESERVE EXISTING PRICE */
        if (
          !priceTouched &&
          existingPriceApplied
        ) {
          if (
            existingPriceMin !== null &&
            !newParams.has('filter.v.price.gte' )
          ) {
            newParams.append('filter.v.price.gte', existingPriceMin);
          }
          if (
            existingPriceMax !== null &&
            !newParams.has('filter.v.price.lte')
          ) {
            newParams.append('filter.v.price.lte', existingPriceMax);
          }
        }
        /*SORT*/
        var sortValue =
          this.getActiveSortValue();
        if (sortValue) {
          newParams.set(
            'sort_by',
            sortValue
          );
        }
        /* DEBUG You can see exactly what is being submitted in browser console.*/
        console.log(
          'FILTER FORM:',
          form
        );
        console.log(
          'FINAL FILTER PARAMS:',
          newParams.toString()
        );
        /* * FETCH COLLECTION */
        this.fetchSection(newParams);
      };
      // FETCH SECTION
      CollectionFacetsRoot.prototype.fetchSection = function (
        searchParams
      ) {
        var container =
          this.getContainer();
        if (!container) return;
        if (
          this.abortController &&
          typeof this.abortController.abort ===
            'function'
        ) {
          this.abortController.abort();
        }
        var signal = null;
        if (window.AbortController) {
          this.abortController =
            new AbortController();
          signal =
            this.abortController.signal;
        } else {
          this.abortController = null;
        }
        if (this.sectionId) {
          searchParams.set(
            'section_id',
            this.sectionId
          );
        }
        var url =
          window.location.pathname +
          '?' +
          searchParams.toString();
        container.classList.add(
          'is-loading'
        );
        var fetchOptions = {
          headers: {
            'X-Requested-With':'XMLHttpRequest'
          }
        };
        if (signal) {
          fetchOptions.signal = signal;
        }
        fetch(url, fetchOptions)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              if (
                signal &&
                signal.aborted
              ) {
                return;
              }
              var temp =
                document.createElement(
                  'div'
                );
              temp.innerHTML = html;
              var newContainer;
              if (this.sectionId) {
                newContainer =
                  temp.querySelector(
                    '.main-collection-contain[data-section-id="' +
                      this.sectionId +
                      '"]'
                  );
              }
              if (!newContainer) {
                newContainer =
                  temp.querySelector(
                    '.main-collection-contain'
                  );
              }
              var newDialog = null;
              if (this.sectionId) {
                newDialog =
                  temp.querySelector(
                    '#filterTabDrawer-' +
                      this.sectionId
                  );
              }
              if (!newContainer) {
                container.classList.remove(
                  'is-loading'
                );
                return;
              }
              /** SORT DIALOG*/
              var newSortDialog =
                temp.querySelector(
                  '#sortDrawer-' +
                    this.sectionId
                );
              if (newSortDialog) {
                var oldSortDialog =
                  document.getElementById(
                    'sortDrawer-' +
                      this.sectionId
                  );
                if (
                  oldSortDialog && oldSortDialog.parentNode
                ) {
                  oldSortDialog.parentNode.replaceChild(
                    newSortDialog, oldSortDialog
                  );
                }
              }
              /** COLLECTION CONTENT*/
              this.replaceInner(
                '[data-collection-toolbar]',
                container, newContainer
              );
              this.replaceInner(
                '[data-collection-filters]',
                container, newContainer
              );
              this.replaceInner(
                '[data-collection-products]',
                container, newContainer
              );
              this.replaceInner(
                '[data-collection-pagination]',
                container, newContainer
              );
              this.replaceInner(
                '[data-load-more]',
                container, newContainer
              );
              /* * Scroll to products/grid.*/
              var utilityGrid =
                document.querySelector(
                  '.utility-grid'
                );
              if (utilityGrid) {
                utilityGrid.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
              /** Replace mobile dialog.*/
              if (newDialog) {
                var oldDialog =
                  this.getDialog();
                if (
                  oldDialog && oldDialog.parentNode
                ) {
                  oldDialog.parentNode.replaceChild(
                    newDialog, oldDialog
                  );
                }
              }
              /** Remove section_id from browser URL.*/
              if (this.sectionId) {
                searchParams.delete(
                  'section_id'
                );
              }
              var finalUrl =
                window.location.pathname;
              var qs =
                searchParams.toString();
              if (qs) {
                finalUrl += '?' + qs;
              }
              window.history.replaceState(
                {},
                '',
                finalUrl
              );
              /** Rebind everything because Shopify AJAX replaced HTML.*/
              this.bindAll();
              container.classList.remove(
                'is-loading'
              );
            }.bind(this)
          )
          .catch(
            function (error) {
              if (
                error &&
                error.name ===
                  'AbortError'
              ) {
                return;
              }
              console.error(
                'Collection filter error:',
                error
              );
              container.classList.remove(
                'is-loading'
              );
            }.bind(this)
          );
      };
      // REPLACE INNER
      CollectionFacetsRoot.prototype.replaceInner = function (
        selector, oldRoot , newRoot
      ) {
        var oldEl =
          oldRoot.querySelector(
            selector
          );
        var newEl =
          newRoot.querySelector(
            selector
          );
        if (oldEl && newEl) {
          oldEl.innerHTML =
            newEl.innerHTML;
          if (
            oldEl.classList.contains(
              'display-none'
            )
          ) {
            oldEl.classList.remove(
              'display-none'
            );
          }
        }
        if (
          (
            selector ===
              '[data-collection-pagination]' ||
            selector ===
              '[data-load-more]'
          ) &&
          oldEl &&
          !newEl
        ) {
          oldEl.innerHTML = '';
        }
      };
      // PRICE RANGE
      CollectionFacetsRoot.prototype.initPriceRanges = function () {
        if (!window.noUiSlider) return;
        var forms =
          this.getFilterForms();
        if (!forms.length) return;
        for (
          var i = 0;
          i < forms.length;
          i++
        ) {
          var ranges =
            forms[i].querySelectorAll(
              '[data-price-range]'
            );
          for (
            var j = 0;
            j < ranges.length;
            j++
          ) {
            this.initSinglePriceRange(
              ranges[j]
            );
          }
        }
      };
      CollectionFacetsRoot.prototype.initSinglePriceRange = function (
        container
      ) {
        var self = this;
        container._priceTouched =
          false;
        var sliderEl =
          container.querySelector(
            '[data-price-slider]'
          );
        var minInput =
          container.querySelector(
            '.input-price-min'
          );
        var maxInput =
          container.querySelector(
            '.input-price-max'
          );
        if (
          !sliderEl || !minInput || !maxInput
        ) {
          return;
        }
        if (sliderEl.noUiSlider) {
          return;
        }
        var dataMin =
          parseFloat(
            container.getAttribute(
              'data-min'
            )
          ) || 0;
        var dataMax =
          parseFloat(
            container.getAttribute(
              'data-max'
            )
          ) || 0;
        var currentMin =
          parseFloat(
            container.getAttribute(
              'data-current-min'
            )
          );
        var currentMax =
          parseFloat(
            container.getAttribute(
              'data-current-max'
            )
          );
        if (isNaN(currentMin)) {
          currentMin = dataMin;
        }
        if (isNaN(currentMax)) {
          currentMax = dataMax;
        }
        if (currentMin < dataMin) {
          currentMin = dataMin;
        }
        if (currentMax > dataMax) {
          currentMax = dataMax;
        }
        if (currentMin > currentMax) {
          currentMin = currentMax;
        }
        noUiSlider.create(
          sliderEl,
          {
            start: [
              currentMin,
              currentMax
            ],
            connect: true,
            range: {
              min: dataMin,
              max: dataMax
            },
            step: 1
          }
        );
        sliderEl.noUiSlider.on(
          'update',
          function (values) {
            var minVal =
              Math.round(values[0]);
            var maxVal =
              Math.round(values[1]);
            minInput.value =minVal;
            maxInput.value = maxVal;
          }
        );
        sliderEl.noUiSlider.on(
          'change',
          function () {
            container._priceTouched =
              true;
            self.syncPriceRangeInputs(
              container
            );
            var form =
              container.closest(
                'form.facets-filter-form[data-facets-form]'
              );
            self.handlePriceFilterChanged(
              form
            );
          }
        );
        function setSliderFromInputs(
          apply
        ) {
          var minVal =
            parseFloat(
              minInput.value
            );
          var maxVal =
            parseFloat(
              maxInput.value
            );
          if (isNaN(minVal)) {
            minVal = dataMin;
          }
          if (isNaN(maxVal)) {
            maxVal = dataMax;
          }
          if (minVal < dataMin) {
            minVal = dataMin;
          }
          if (maxVal > dataMax) {
            maxVal = dataMax;
          }
          if (minVal > maxVal) {
            minVal = maxVal;
          }
          sliderEl.noUiSlider.set([
            minVal,
            maxVal
          ]);
          self.syncPriceRangeInputs(
            container
          );
          if (apply) {
            var form =
              container.closest(
                'form.facets-filter-form[data-facets-form]'
              );
            self.handlePriceFilterChanged(
              form
            );
          }
        }
        minInput.addEventListener(
          'change',
          function () {
            container._priceTouched =
              true;
            setSliderFromInputs(true);
          }
        );
        maxInput.addEventListener(
          'change',
          function () {
            container._priceTouched =
              true;
            setSliderFromInputs(true);
          }
        );
      };
      // PRICE FILTER CHANGE
      CollectionFacetsRoot.prototype.handlePriceFilterChanged = function (
        sourceForm
      ) {
        var horizontal =
          this.isHorizontalFiltersActive();
        /** MOBILE / HORIZONTAL Enable Apply only.*/
        if (
          horizontal ||
          isMobile()
        ) {
          var form =
            sourceForm;
          if (!form) {
            form = isMobile()
              ? this.getMobileFilterForm()
              : this.getDesktopFilterForm();
          }
          if (form) {
            var btn =
              form.querySelector(
                'button[type="submit"], input[type="submit"]'
              );
            if (btn) {
              btn.disabled = false;
              btn.classList.add(
                'facets-submit-active'
              );
            }
          }
          return;
        }
        /** DESKTOPApply immediately.*/
        this.updateCollectionFromState(
          sourceForm ||
            this.getDesktopFilterForm()
        );
      };
      // HORIZONTAL FILTERS
      CollectionFacetsRoot.prototype.bindHorizontalFilterTriggers = function () {
        var container =
          this.getContainer();
        if (!container) return;
        var triggers =
          container.querySelectorAll(
            '[data-filter-dialog]'
          );
        if (!triggers.length) return;
        for (
          var i = 0;
          i < triggers.length;
          i++
        ) {
          var btn =
            triggers[i];
          if (
            btn.getAttribute(
              'data-filter-dialog-bound'
            ) === 'true'
          ) {
            continue;
          }
          btn.setAttribute(
            'data-filter-dialog-bound',
            'true'
          );
          btn.addEventListener(
            'click',
            this.onHorizontalTriggerClickHandler
          );
        }
      };
      CollectionFacetsRoot.prototype.onHorizontalTriggerClick = function (
        event
      ) {
        this.preventEvent(event);
        var trigger =
          event.currentTarget;
        var dialogId =
          trigger.getAttribute(
            'data-filter-dialog'
          );
        var headingId =
          trigger.getAttribute(
            'data-tab-heading'
          );
        if (!dialogId) return;
        var dialog =
          document.getElementById(
            dialogId
          );
        if (!dialog) return;
        this.openDialog(
          dialog,
          trigger
        );
        this.bindDialogTabs(
          dialog
        );
        this.bindDialogClose(
          dialog
        );
        this.bindMobileClearFilters(
          dialog
        );
        this.bindMobileDragToClose(
          dialog
        );
        this.bindMobileApplyButtons();
        if (!isMobile()) {
          if (headingId) {
            var targetTab =
              dialog.querySelector(
                '#' + headingId
              );
            if (targetTab) {
              this.activateDialogTab(
                targetTab,
                dialog
              );
              return;
            }
          }
          var firstTab =
            dialog.querySelector(
              '.filter-dl-tabs span[data-target]'
            );
          if (firstTab) {
            this.activateDialogTab(
              firstTab,
              dialog
            );
          }
        } else {
          var panels =
            dialog.querySelectorAll(
              '.filter-dl-panel'
            );
          var tabs =
            dialog.querySelectorAll(
              '.filter-dl-tabs span'
            );
          for (
            var i = 0;
            i < panels.length;
            i++
          ) {
            panels[i].classList.remove(
              'is-active'
            );
          }
          for (
            var j = 0;
            j < tabs.length;
            j++
          ) {
            tabs[j].classList.remove(
              'is-active'
            );
          }
          return;
        }
      };
      // DIALOG TABS
      CollectionFacetsRoot.prototype.bindDialogTabs = function (
        dialog
      ) {
        dialog =
          dialog ||
          this.getDialog();
        if (!dialog) return;
        var tabs =
          dialog.querySelectorAll(
            '.filter-dl-tabs span[data-target]'
          );
        for (
          var i = 0;
          i < tabs.length;
          i++
        ) {
          var tab =
            tabs[i];

          tab.setAttribute(
            'role',
            'tab'
          );
          tab.setAttribute(
            'aria-selected',
            tab.classList.contains(
              'is-active'
            )
              ? 'true'
              : 'false'
          );
          var panelId =
            tab.getAttribute(
              'data-target'
            );
          if (panelId) {
            tab.setAttribute(
              'aria-controls',
              panelId
            );
          }
          if (
            tab.getAttribute(
              'data-tab-bound'
            ) !== 'true'
          ) {
            tab.setAttribute(
              'data-tab-bound',
              'true'
            );
            tab.addEventListener(
              'click',
              this.onDialogTabClickHandler
            );
            tab.addEventListener(
              'keydown',
              this.onDialogTabKeydown.bind(
                this
              )
            );
          }
        }
        var tabList =
          dialog.querySelector(
            '.filter-dl-tabs'
          );
        if (tabList) {
          tabList.setAttribute(
            'role',
            'tablist'
          );
        }
      };
      CollectionFacetsRoot.prototype.onDialogTabClick = function (
        event
      ) {
        this.preventEvent(event);
        var tab =
          event.currentTarget;
        if (!tab) return;
        var dialog =
          tab.closest('dialog');
        if (!dialog) {
          dialog =
            this.getDialog();
        }
        if (!dialog) return;
        this.activateDialogTab(
          tab,
          dialog
        );
      };
      CollectionFacetsRoot.prototype.activateDialogTab = function (
        tab,
        dialog
      ) {
        if (!dialog || !tab) {
          return;
        }
        var targetId =
          tab.getAttribute( 'data-target' );
        var allTabs =
          dialog.querySelectorAll('.filter-dl-tabs span[data-target]');
        var allPanels =
          dialog.querySelectorAll('.filter-dl-panel');
        for (
          var i = 0;
          i < allTabs.length;
          i++
        ) {
          allTabs[i].classList.remove(
            'is-active'
          );
          allTabs[i].setAttribute(
            'aria-selected',
            'false'
          );
          allTabs[i].setAttribute(
            'tabindex',
            '-1'
          );
        }
        for (
          var j = 0;
          j < allPanels.length;
          j++
        ) {
          allPanels[j].classList.remove(
            'is-active'
          );
          allPanels[j].setAttribute(
            'hidden',
            'hidden'
          );
        }
        tab.classList.add(
          'is-active'
        );
        tab.setAttribute(
          'aria-selected',
          'true'
        );
        tab.setAttribute(
          'tabindex',
          '0'
        );
        if (targetId) {
          var panel =
            dialog.querySelector(
              '#' + targetId
            );
          if (panel) {
            panel.classList.add(
              'is-active'
            );
            panel.removeAttribute(
              'hidden'
            );
            panel.setAttribute(
              'role',
              'tabpanel'
            );
            panel.setAttribute(
              'aria-labelledby',
              tab.id
            );
          }
        }
      };
      CollectionFacetsRoot.prototype.onDialogTabKeydown = function (
        event
      ) {
        var key =
          event.key ||
          event.keyCode;
        var currentTab =
          event.currentTarget;
        var dialog =
          currentTab.closest(
            'dialog'
          );
        if (!dialog) return;
        var tabs =
          dialog.querySelectorAll(
            '.filter-dl-tabs span[data-target]'
          );
        if (!tabs.length) return;
        var currentIndex = -1;
        for (
          var i = 0;
          i < tabs.length;
          i++
        ) {
          if (
            tabs[i] === currentTab
          ) {
            currentIndex = i;
            break;
          }
        }
        if (currentIndex === -1) {
          return;
        }
        var nextIndex =
          currentIndex;
        if (
           key === 'ArrowRight' || key === 'ArrowDown' || key === 39 || key === 40
        ) {
          event.preventDefault();
          nextIndex =
            currentIndex + 1;
          if (
            nextIndex >= tabs.length
          ) {
            nextIndex = 0;
          }
          tabs[nextIndex].focus();
          this.activateDialogTab(
            tabs[nextIndex],
            dialog
          );
          return;
        }
        if (
          key === 'ArrowLeft' ||  key === 'ArrowUp' ||  key === 37 || key === 38
        ) {
          event.preventDefault();
          nextIndex =
            currentIndex - 1;
          if (nextIndex < 0) {
            nextIndex =
              tabs.length - 1;
          }
          tabs[nextIndex].focus();
          this.activateDialogTab(
            tabs[nextIndex],
            dialog
          );
          return;
        }
        if (
          key === 'Home' ||key === 36
        )  {
          event.preventDefault();
          tabs[0].focus();
          this.activateDialogTab(
            tabs[0],
            dialog
          );
          return;
        }
        if (
          key === 'End' ||
          key === 35
        ) {
          event.preventDefault();
          tabs[tabs.length - 1].focus();
          this.activateDialogTab(
            tabs[tabs.length - 1],
            dialog
          );
          return;
        }
        if ( key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32
        ) {
          event.preventDefault();
          this.activateDialogTab(
            currentTab,
            dialog
          );
        }
      };
      // DIALOG OPEN / CLOSE
      CollectionFacetsRoot.prototype.openDialog = function (
        dialog
      ) {
        if (!dialog) return;
        if (dialog.showModal) {
          dialog.showModal();
        } else {
          dialog.setAttribute(
            'open',
            'open'
          );
        }
        dialog.classList.add(
          'is-active'
        );
        this.lockBodyScroll();
        if (window.FocusTrap) {
          var self = this;
          var initialFocus =
            dialog.querySelector( '.dialog-close') ||
            dialog.querySelector('[data-filter-dl-header]' ) ||
            dialog.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' );
          window.FocusTrap.trap(
            dialog,
            initialFocus,
            this._handleDialogEsc.bind(
              this,
              dialog
            )
          );
        }
      };
      CollectionFacetsRoot.prototype.closeDialog = function (
        dialog
      ) {
        if (!dialog) return;
        if (window.FocusTrap) {
          window.FocusTrap.release(
            dialog
          );
        }
        if (dialog.close) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        dialog.classList.remove('is-active');
        this.unlockBodyScroll();
      };
      CollectionFacetsRoot.prototype._handleDialogEsc = function (
        dialog
      ) {
        if (!dialog) return;
        if (window.FocusTrap) {
          window.FocusTrap.release(
            dialog
          );
        }
        if (isMobile()) {
          this.closeDialogWithSlide(
            dialog
          );
        } else {
          this.closeDialog(
            dialog
          );
        }
      };
      CollectionFacetsRoot.prototype.activateDefaultDialogTab = function (
        dialog
      ) {
        if (!dialog) return;
        var activeTab =
          dialog.querySelector(
            '.filter-dl-tabs span[data-target].is-active'
          );
        if (!activeTab) {
          activeTab =
            dialog.querySelector(
              '.filter-dl-tabs span[data-target]'
            );
        }
        if (activeTab) {
          this.activateDialogTab(
            activeTab,
            dialog
          );
        }
      };
      CollectionFacetsRoot.prototype.closeDialogWithSlide = function (
        dialog
      ) {
        if (!dialog) {
          dialog =
            this.getDialog();
        }
        if (!dialog) return;
        if (!isMobile()) {
          this.closeDialog(
            dialog
          );
          return;
        }
        var panel =
          dialog.querySelector(
            '.dialog-inner'
          );
        var bgLayer =
          dialog.querySelector(
            '.dialog-bg-layer'
          );
        if (!panel) {
          this.closeDialog(
            dialog
          );
          return;
        }
        panel.style.transition = 'transform 0.25s ease-out';
        panel.style.transform ='translateY(100%)';
        if (bgLayer) {
          bgLayer.style.transition =
            'opacity 0.25s ease-out';
            bgLayer.style.opacity ='0';
        }
        var self = this;
        window.setTimeout(
          function () {
            panel.style.transform ='';
            panel.style.transition ='';
            if (bgLayer) {
              bgLayer.style.opacity = '';
              bgLayer.style.transition ='';
            }
            self.closeDialog(
              dialog
            );
          },
          250
        );
      };
      // DIALOG CLOSE
      CollectionFacetsRoot.prototype.bindDialogClose = function (
        dialog
      ) {
        dialog =
          dialog ||
          this.getDialog();
        if (!dialog) return;
        var closeBtn =
          dialog.querySelector(
            '.dialog-close'
          );
        var bgLayer =
          dialog.querySelector(
            '.dialog-bg-layer'
          );
        var self = this;
        function bindClose(el) {
          if (!el) return;
          if (
            el.getAttribute(
              'data-dialog-close-bound'
            ) === 'true'
          ) {
            return;
          }
          el.setAttribute(
            'data-dialog-close-bound',
            'true'
          );
          el.addEventListener(
            'click',
            function () {
              if (isMobile()) {
                self.closeDialogWithSlide(
                  dialog
                );
              } else {
                self.closeDialog(
                  dialog
                );
              }
            }
          );
        }
        bindClose(closeBtn);
        bindClose(bgLayer);
      };
      // CLEAR FILTERS
      CollectionFacetsRoot.prototype.bindMobileClearFilters = function (
        dialog
      ) {
        dialog =
          dialog ||
          this.getDialog();
        if (!dialog) return;
        var clearLink =
          dialog.querySelector(
            '[data-clear-filters]'
          );
        if (!clearLink) return;
        var self = this;
        if (
          clearLink.getAttribute(
            'data-clear-bound'
          ) === 'true'
        ) {
          return;
        }
        clearLink.setAttribute(
          'data-clear-bound',
          'true'
        );
        clearLink.addEventListener(
          'click',
          function (event) {
            self.preventEvent(event);
            var href =
              clearLink.getAttribute(
                'href'
              ) ||
              window.location.pathname;
            var params =
              createSearchParamsFromUrl(
                href
              );
            self.fetchSection(
              params
            );
            if (isMobile()) {
              self.closeDialogWithSlide(
                dialog
              );
            } else {
              self.closeDialog(
                dialog
              );
            }
          }
        );
      };
      // SYNC DESKTOP / MOBILE CONTROLS
      CollectionFacetsRoot.prototype.syncFacetControlState = function (
        sourceControl
      ) {
        if (
          !sourceControl ||
          !sourceControl.name
        ) {
          return;
        }
        var sourceType =
          (
            sourceControl.type ||
            ''
          ).toLowerCase();
        var sourceName =
          sourceControl.name;
        var sourceValue =
          sourceControl.value;
        var forms =
          this.getFilterForms();
        for (
          var i = 0;
          i < forms.length;
          i++
        ) {
          var controls =
            forms[i].querySelectorAll(
              '[name="' +
                sourceName +
                '"]'
            );
          for (
            var j = 0;
            j < controls.length;
            j++
          ) {
            var control =
              controls[j];
            if (
              control ===
              sourceControl
            ) {
              continue;
            }
            if (
              sourceType ===
              'checkbox'
            ) {
              if (
                control.value ===
                sourceValue
              ) {
                control.checked =
                  sourceControl.checked;
              }
              continue;
            }
            if (
              sourceType ===
              'radio'
            ) {
              control.checked =
                control.value ===
                sourceValue;
              continue;
            }
            control.value =
              sourceValue;
          }
        }
      };
      CollectionFacetsRoot.prototype.syncPriceRangeInputs = function (
        sourceContainer
      ) {
        if (!sourceContainer) {
          return;
        }
        var sourceMin =
          sourceContainer.querySelector(
            '.input-price-min'
          );
        var sourceMax =
          sourceContainer.querySelector(
            '.input-price-max'
          );
        var forms =
          this.getFilterForms();
        for (
          var i = 0;
          i < forms.length;
          i++
        ) {
          var container =
            forms[i].querySelector(
              '[data-price-range]'
            );
          if (
            !container ||
            container ===
              sourceContainer
          ) {
            continue;
          }
          var minInput =
            container.querySelector(
              '.input-price-min'
            );
          var maxInput =
            container.querySelector(
              '.input-price-max'
            );
          if (
            minInput &&
            sourceMin
          ) {
            minInput.value =
              sourceMin.value;
          }
          if (
            maxInput &&
            sourceMax
          ) {
            maxInput.value =
              sourceMax.value;
          }
          container._priceTouched =
            sourceContainer._priceTouched ===
            true;
        }
      };
      // ACTIVE FILTER COUNTS
      CollectionFacetsRoot.prototype.syncActiveFilterCounts = function (
        name
      ) {
        if (
          !name ||
          name.indexOf(
            'filter.'
          ) !== 0
        ) {
          return;
        }
        var forms =
          this.getFilterForms();
        for (
          var i = 0;
          i < forms.length;
          i++
        ) {
          var input =
            forms[i].querySelector(
              'input[name="' +
                name +
                '"]'
            );
          if (!input) {
            continue;
          }
          this.updateActiveFilterCount(
            forms[i],
            input
          );
        }
      };
      CollectionFacetsRoot.prototype.updateActiveFilterCount = function (
        form,
        input
      ) {
        if (!form || !input) {
          return;
        }
        var name =
          input.name;
        if (
          !name ||
          name.indexOf(
            'filter.'
          ) !== 0
        ) {
          return;
        }
        var inputs =
          form.querySelectorAll(
            'input[name="' +
              name +
              '"]'
          );
        var count = 0;
        for (
          var i = 0;
          i < inputs.length;
          i++
        ) {
          if (
            inputs[i].checked
          ) {
            count++;
          }
        }
        var wrapper =
          input.closest(
            '[data-dialog-filter-wrapper], .utility-group'
          );
        if (!wrapper) {
          return;
        }
        var counter =
          wrapper.querySelector(
            '[data-active-values-count]'
          );
        if (!counter) {
          return;
        }
        counter.textContent =
          '(' + count + ')';
        if (count === 0) {
          counter.classList.add(
            'display-none'
          );
        } else {
          counter.classList.remove(
            'display-none'
          );
        }
      };
      // MOBILE DRAG TO CLOSE
      CollectionFacetsRoot.prototype.bindMobileDragToClose = function (
        dialog
      ) {
        dialog =
          dialog ||
          this.getDialog();
        if (!dialog) return;
        if (!isMobile()) {
          return;
        }
        var dragHandle =
          dialog.querySelector(
            '[data-drawer-drag-handle]'
          );
        var panel =
          dialog.querySelector(
            '.dialog-inner'
          );
        var bgLayer =
          dialog.querySelector(
            '.dialog-bg-layer'
          );
        var self = this;
        if (
          !dragHandle ||
          !panel
        ) {
          return;
        }
        if (
          dragHandle.getAttribute(
            'data-drag-bound'
          ) === 'true'
        ) {
          return;
        }
        dragHandle.setAttribute(
          'data-drag-bound',
          'true'
        );
        var startY = 0;
        var currentY = 0;
        var dragging = false;
        var threshold = 80;
        function onTouchStart(e) {
          if (
            !e.touches ||
            !e.touches.length
          ) {
            return;
          }
          dragging = true;
          startY =
            e.touches[0].clientY;
          currentY =
            startY;
          panel.style.transition =
            'none';
          if (bgLayer) {
            bgLayer.style.transition =
              'none';
          }
        }
        function onTouchMove(e) {
          if (
            !dragging ||
            !e.touches ||
            !e.touches.length
          ) {
            return;
          }
          currentY =
            e.touches[0].clientY;
          var deltaY =
            currentY -
            startY;
          if (deltaY < 0) {
            deltaY = 0;
          }
          panel.style.transform =
            'translateY(' +
            deltaY +
            'px)';
          if (bgLayer) {
            var opacity =
              Math.max(
                0,
                1 -
                  deltaY /
                    300
              );
            bgLayer.style.opacity =
              String(opacity);
          }
        }
        function onTouchEnd() {
          if (!dragging) {
            return;
          }
          dragging = false;
          var deltaY =
            currentY -
            startY;
          panel.style.transition =
            'transform 0.25s ease-out';
          if (bgLayer) {
            bgLayer.style.transition =
              'opacity 0.25s ease-out';
          }
          if (
            deltaY >
            threshold
          ) {
            panel.style.transform =
              'translateY(100%)';
            if (bgLayer) {
              bgLayer.style.opacity =
                '0';
            }
            window.setTimeout(
              function () {
                panel.style.transform =
                  '';
                panel.style.transition =
                  '';
                if (bgLayer) {
                  bgLayer.style.opacity =
                    '';
                  bgLayer.style.transition =
                    '';
                }
                self.closeDialog(
                  dialog
                );
              },
              250
            );
          } else {
            panel.style.transform =
              'translateY(0px)';
            if (bgLayer) {
              bgLayer.style.opacity =
                '';
            }
            window.setTimeout(
              function () {
                panel.style.transition =
                  '';
                if (bgLayer) {
                  bgLayer.style.transition =
                    '';
                }
              },
              250
            );
          }
        }
        dragHandle.addEventListener(
          'touchstart',
          onTouchStart,
          {
            passive: true
          }
        );
        dragHandle.addEventListener(
          'touchmove',
          onTouchMove,
          {
            passive: true
          }
        );
        dragHandle.addEventListener(
          'touchend',
          onTouchEnd
        );
        dragHandle.addEventListener(
          'touchcancel',
          onTouchEnd
        );
      };
      // SORT DIALOG
      CollectionFacetsRoot.prototype.bindSortDialogTriggers = function () {
        var triggers =
          document.querySelectorAll(
            '[data-sort-dialog]'
          );
        if (!triggers.length) {
          return;
        }
        for (
          var i = 0;
          i < triggers.length;
          i++
        ) {
          var btn =
            triggers[i];
          if (
            btn.getAttribute(
              'data-sort-dialog-bound'
            ) === 'true'
          ) {
            continue;
          }
          btn.setAttribute(
            'data-sort-dialog-bound',
            'true'
          );
          btn.addEventListener(
            'click',
            this.onSortDialogTriggerClickHandler
          );
        }
      };
      CollectionFacetsRoot.prototype.onSortDialogTriggerClick = function (
        event
      ) {
        this.preventEvent(event);
        var btn =
          event.currentTarget;
        var dialogId =
          btn.getAttribute(
            'data-sort-dialog'
          );
        if (!dialogId) {
          return;
        }
        var dialog =
          document.getElementById(
            dialogId
          );
        if (!dialog) {
          return;
        }
        this.openDialog(
          dialog,
          btn
        );
        this.bindDialogClose(
          dialog
        );
        this.bindMobileDragToClose(
          dialog
        );
        this.bindSortDialogOptions(
          dialog
        );
      };
      CollectionFacetsRoot.prototype.bindSortDialogOptions = function (
        dialog
      ) {
        var inputs =
          dialog.querySelectorAll(
            'input[name="sort_by"]'
          );
        for (
          var i = 0;
          i < inputs.length;
          i++
        ) {
          var input =
            inputs[i];
          if (
            input.getAttribute(
              'data-sort-bound'
            ) === 'true'
          ) {
            continue;
          }
          input.setAttribute(
            'data-sort-bound',
            'true'
          );
          var self = this;
          input.addEventListener(
            'change',
            function () {
              /**Sort should preserve current* desktop/applied filters.*/
              self.updateCollectionFromState(
                self.getDesktopFilterForm()
              );
              if (isMobile()) {
                self.closeDialogWithSlide(
                  dialog
                );
              } else {
                self.closeDialog(
                  dialog
                );
              }
            }
          );
        }
      };
      CollectionFacetsRoot.prototype.getActiveSortValue = function () {
        if (this.sectionId) {
          var dialog =
            document.getElementById(
              'sortDrawer-' +
                this.sectionId
            );
          if (
            dialog &&
            dialog.classList.contains(
              'is-active'
            )
          ) {
            var dlgChecked =
              dialog.querySelector(
                'input[name="sort_by"]:checked'
              );
            if (
              dlgChecked &&
              dlgChecked.value
            ) {
              return dlgChecked.value;
            }
          }
        }
        var container =
          this.getContainer();
        if (container) {
          var desktopChecked =
            container.querySelector(
              '.utility-select-option input[name="sort_by"]:checked'
            );
          if (
            desktopChecked &&
            desktopChecked.value
          ) {
            return desktopChecked.value;
          }
        }
        return null;
      };
      // BODY SCROLL
      CollectionFacetsRoot.prototype.lockBodyScroll = function () {
        document.body.classList.add(
          'overflow-hide'
        );
      };
      CollectionFacetsRoot.prototype.unlockBodyScroll = function () {
        var openDialogs =
          document.querySelectorAll(
            'dialog.is-active,dialog.is-open,.dialog.is-active,.dialog.is-open'
          );

        if (
          openDialogs.length ===
          0
        ) {
          document.body.classList.remove(
            'overflow-hide'
          );
        }
      };
      // MOBILE PANEL CLOSE
      CollectionFacetsRoot.prototype.bindMobilePanelClose = function () {
        if (!isMobile()) {
          return;
        }
        var elements =
          document.querySelectorAll(
            '[data-dl-panel-close]'
          );
        if (!elements.length) {
          return;
        }
        for (
          var i = 0;
          i < elements.length;
          i++
        ) {
          var el =
            elements[i];
          if (
            el.getAttribute(
              'data-dl-panel-close-bound'
            ) === 'true'
          ) {
            continue;
          }
          el.setAttribute(
            'data-dl-panel-close-bound',
            'true'
          );
          el.addEventListener(
            'click',
            function () {
              var panel =
                this.closest(
                  '.filter-dl-panel'
                );
              if (!panel) {
                return;
              }
              panel.classList.remove(
                'is-active'
              );
            }
          );
        }
      };
      // RESIZE WATCHER
      CollectionFacetsRoot.prototype.bindResizeWatcher = function () {
        var self = this;
        if (this._resizeBound) {
          return;
        }
        this._resizeBound = true;
        window.addEventListener(
          'resize',
          function () {
            if (!isMobile()) {
              self.closeAllDialogs();
            }
          }
        );
      };
      CollectionFacetsRoot.prototype.closeAllDialogs = function () {
        var dialogs =
          document.querySelectorAll(
            '.filter-dialog.is-active'
          );
        for (
          var i = 0;
          i < dialogs.length;
          i++
        ) {
          this.closeDialog(
            dialogs[i]
          );
        }
      };
      // UTILS
      CollectionFacetsRoot.prototype.preventEvent = function (
        event
      ) {
        if (!event) return;
        if (event.preventDefault) {
          event.preventDefault();
        }
        event.returnValue = false;
      };
      return CollectionFacetsRoot;
    })();
    customElements.define(
      'collection-facets-root',
      CollectionFacetsRoot
    );
  }
  // LOAD MORE
  document.addEventListener(
    'click',
    async function (e) {
      const button =
        e.target.closest(
          '.load-more-btn'
        );
      if (!button) return;
      e.preventDefault();
      const page =
        Number(
          button.dataset.nextPage
        );
      const section =
        button.closest(
          '.shopify-section'
        );
      if (!section) {
        return;
      }
      const sectionId =
        section.id.replace(
          'shopify-section-',
          ''
        );
      const url =
        new URL(
          window.location.href
        );
      url.searchParams.set(
        'page',
        page
      );
      url.searchParams.set(
        'section_id',
        sectionId
      );
      button.disabled = true;
      try {
        const response =
          await fetch(
            url.toString()
          );
        const html =
          await response.text();

        const doc =
          new DOMParser().parseFromString(
            html,
            'text/html'
          );
        const newProducts =
          doc.querySelector(
            '[data-collection-products]'
          );

        const currentProducts =
          document.querySelector(
            '[data-collection-products]'
          );

        if (
          newProducts &&
          currentProducts
        ) {
          currentProducts.insertAdjacentHTML(
            'beforeend',
            newProducts.innerHTML
          );
        }
        const newLoadMore =
          doc.querySelector(
            '[data-load-more]'
          );
        const currentLoadMore =
          document.querySelector(
            '[data-load-more]'
          );
        if (
          newLoadMore &&
          currentLoadMore
        ) {
          currentLoadMore.innerHTML =
            newLoadMore.innerHTML;
        }
      } catch (error) {
        console.error(
          'Load more error:',
          error
        );
        button.disabled = false;
      }
    }
  );
})();